import { Colors } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import Icon24 from 'builder/components/Icon'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ListItem = styled.div`
  display: flex;
  gap: 8px;
`

export const ListIcon = styled(Icon24.Tick)`
  color: ${Colors.Green40};
`
